import React from 'react';
import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
} from '@chakra-ui/react';
import { format } from 'date-fns';

const AlarmReportTable = ({ data }) => {
  if (!data || data.length === 0) {
    return <Box>No data to display</Box>;
  }

  // Kullanıcı dostu sütun başlıkları
  const columnHeaders = {
    time: 'Time',
    code: 'Code',
    status: 'Status',
    name: 'Name',
    group: 'Group',
  };
  const columnsToShow = Object.keys(columnHeaders);

  // Tablo satırlarını oluşturma
  const rows = data.map((item, index) => (
    <Tr key={`${item.id}-${index}`}>
      {columnsToShow.map(column => (
        <Td key={`${column}-${index}`}>
          {column === 'time'
            ? format(new Date(item[column]), 'dd/MM/yyyy HH:mm:ss') // Time alanını formatla
            : column === 'status'
              ? item[column] === true
                ? 'I' // True ise "I" göster
                : 'O' // False ise "O" göster
              : item[column]?.toString() || 'N/A'}
        </Td>
      ))}
    </Tr>
  ));

  return (
    <Box w="100%" className="printable-content">
      <TableContainer>
        <Table variant="striped" colorScheme="gray">
          <Thead>
            <Tr>
              {columnsToShow.map(column => (
                <Th key={column}>{columnHeaders[column]}</Th>
              ))}
            </Tr>
          </Thead>
          <Tbody>{rows}</Tbody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default AlarmReportTable;
